import { IconButton } from '@/components/ui/icon-button'
import * as Menu from '@/components/ui/menu'
import type { MenuSelectionDetails } from '@ark-ui/solid'
import { A } from '@solidjs/router'
import { useAuth } from '@stateApp'
import {
  Briefcase,
  EllipsisVertical,
  Glasses,
  LayoutDashboard,
  ListTodo,
  MoreHorizontal,
  PenTool,
  Scale,
  Scroll,
  Trophy
} from 'lucide-solid'
import { useService } from 'solid-services'
import { HStack } from 'styled-system/jsx'

enum Options {
  Delete = 'Delete',
  Edit = 'Edit',
  CopyLink = 'CopyLink',
  App = 'App',
  HvfDrawTool = 'HvfDrawTool',
  Brokers = 'Brokers',
  Ranks = 'Ranks',
  TermsAndConditions = 'Terms and Conditions',
  PrivacyPolicy = 'Privacy Policy',
  CodeOfConduct = 'Code of Conduct',
  Feedback = 'Feedback',
}

export default function More() {
  const { isSuper } = useService(useAuth)()

  return (
    <Menu.Root
      onSelect={(details: MenuSelectionDetails) => {
        // Handle Delete, Edit, CopyLink actions here
      }}
      positioning={{
        offset: { mainAxis: -15 },
      }}
    >
      <Menu.Trigger asChild={props => (
        // Note: Make sure to call props() if you update to latest Ark UI versions
        <IconButton {...props} variant="plain" size="xs">
          <EllipsisVertical />
        </IconButton>
      )} />
      <Menu.Positioner>
        <Menu.Content>

          {/* Static Page Links */}
          <Menu.ItemGroup>
            <Menu.Item value={Options.App} asChild={props => (
              <A href="/info/app" {...props}>
                <HStack gap={2}>
                  <LayoutDashboard size={16} /> App
                </HStack>
              </A>
            )} />

            <Menu.Item value={Options.HvfDrawTool} asChild={props => (
              <A href="/info/hvf-draw-tool" {...props}>
                <HStack gap={2}>
                  <PenTool size={16} /> HVF Draw Tool
                </HStack>
              </A>
            )} />

            <Menu.Item value={Options.Brokers} asChild={props => (
              <A href="/info/brokers" {...props}>
                <HStack gap={2}>
                  <Briefcase size={16} /> Brokers
                </HStack>
              </A>
            )} />

            <Menu.Item value={Options.Ranks} asChild={props => (
              <A href="/info/ranks" {...props}>
                <HStack gap={2}>
                  <Trophy size={16} /> Ranks
                </HStack>
              </A>
            )} />

            <Menu.Item value={Options.TermsAndConditions} asChild={props => (
              <A href="/static/terms-and-conditions" {...props}>
                <HStack gap={2}>
                  <Scroll size={16} /> Terms and Conditions
                </HStack>
              </A>
            )} />

            <Menu.Item value={Options.PrivacyPolicy} asChild={props => (
              <A href="/static/privacy-policy" {...props}>
                <HStack gap={2}>
                  <Glasses size={16} /> Privacy Policy
                </HStack>
              </A>
            )} />

            <Menu.Item value={Options.CodeOfConduct} asChild={props => (
              <A href="/static/code-of-conduct" {...props}>
                <HStack gap={2}>
                  <Scale size={16} /> Code of Conduct
                </HStack>
              </A>
            )} />

            <Menu.Item value={Options.Feedback} asChild={props => (
              <A href="https://docs.google.com/forms/d/e/1FAIpQLSftwEzZjvcPjhv3InW-sZzAn7TVqTNONw6TAJXrqwJefyz6WQ/viewform" {...props}>
                <HStack gap={2}>
                  <ListTodo size={16} /> Feedback
                </HStack>
              </A>
            )} />

          </Menu.ItemGroup>
        </Menu.Content>
      </Menu.Positioner>
    </Menu.Root>
  )
}
